var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchmsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3121 19.8397L22.3307 19.857L22.3511 19.8724L25.7525 22.4376L25.8861 22.5384H25.8934C26.2441 22.9897 26.2027 23.6188 25.7693 24.0281C25.2773 24.4927 24.4708 24.496 23.9744 24.0379L21.1634 21.0279L21.1634 21.0279L21.1607 21.0251L21.0645 20.9237C20.9443 20.7771 20.8811 20.6004 20.8811 20.4212C20.8811 20.2084 20.9703 19.9982 21.1393 19.8385C21.4623 19.5401 21.9897 19.5405 22.3121 19.8397ZM11.4206 0.5C14.3258 0.5 17.1067 1.59015 19.1528 3.52237C21.198 5.45367 22.3411 8.06676 22.3411 10.785C22.3411 16.4386 17.4792 21.0699 11.4206 21.0699C5.36194 21.0699 0.5 16.4386 0.5 10.785C0.5 5.13133 5.36194 0.5 11.4206 0.5Z",
    fill: "#FFEA32",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchmsg);
export default __webpack_public_path__ + "static/media/search msg.50539f210f20fb4097bb37b7e68fbbb6.svg";
export { ForwardRef as ReactComponent };